module.exports = __webpack_public_path__ + "static/media/UNI-BNB.f46d6ed4.svg";